import axios from "axios";
import { REACT_APP_API_BASE_URL } from "../Constants/APIConstants";

const isDdevDevEnvironment =
  process.env.NODE_ENV === "development" && REACT_APP_API_BASE_URL?.includes(".ddev.site");

const apiClient = axios.create({
  // In local dev, use CRA proxy to avoid cross-origin 500 responses from ddev.
  baseURL: isDdevDevEnvironment ? "" : REACT_APP_API_BASE_URL,
  timeout: 10000,
  headers: { "Cache-Control": "no-cache" },
});

export default apiClient;
